import React, {FC} from 'react';
import {Typography, Link} from '@bonprix/design-system';

import SupportItem from './SupportItem';
import type {StaticLinks} from './CheckoutFooter';
import LandmarkAdapter from '@core/scripts/components/landmark-adapter';

interface LegalSectionProps {
    texts: {[key: string]: string};
    staticLinks: StaticLinks;
}

const SupportSection: FC<LegalSectionProps> = ({texts, staticLinks}) => {
    const onContactFormClick = () => LandmarkAdapter.sendClickLandmark('contactForm');
    return (
        <div className="flex flex-col gap-9 pt-7 pb-12 l:pt-0 l:pb-0 items-center justify-center l:justify-start l:items-start">
            <Typography variant="h3" component="h2">
                {texts.footerHeadlineCheckout}
            </Typography>
            <div className="flex flex-col gap-9 l:gap-6">
                <SupportItem icon="phone">
                    <Typography>{texts.footerContactBoxCallUs}</Typography>
                    <Link href={texts.linkServicePhone} hideUnderline>
                        <Typography variant="h3">{texts.servicePhoneNumber}</Typography>
                    </Link>
                </SupportItem>
                <SupportItem icon="mail">
                    <Typography>{texts.footerContactBoxMailUs}</Typography>
                    <Link href={staticLinks.SERVICE_CONTACT} onClick={onContactFormClick}>
                        {texts.footerOpenContactForm}
                    </Link>
                </SupportItem>
            </div>
        </div>
    );
};

export default SupportSection;
